import styles from './ExcelWorkOne.module.css'
import MainFormTemplate from "../../FormTemplate/MainFormTemplate/MainFormTemplate";
import React, {useEffect, useRef, useState} from "react";
import InputItem from "../../FormTemplate/InputItem/InputItem";
import WaitLoader from "../../WaitLoader/WaitLoader";
import useApiQuery from "../../ApiQuery/UseApiQuery";
import {Link} from "react-router-dom";
import {ReduxStateInt} from "../../Reducer/GlobalReducer";
import {useSelector} from "react-redux";
import LoggerItem, {ILoggerItem} from "../../FormTemplate/LoggerItem/LoggerItem";
import SelectUnit, {SelectUnitDataInt} from "../../FormTemplate/SelectUnit/SelectUnit";
import ErrorLineItem, {ErrorLineItemRef} from "../../FormTemplate/ErrorLineItem/ErrorLineItem";
import errorLineItem from "../../FormTemplate/ErrorLineItem/ErrorLineItem";
import {Button, ButtonGroup, ToggleButton} from "react-bootstrap";
import useLongTask from "../../Util/LongTaskItem/UseLongTask";
interface IBundleItem
{
    name:string
    bundleId:string
}
interface ITarifItem
{
    name:string
    bundleId:string
    tarifId:string
}


export default function ExcelWorkOne(){

    const amountData = useRef<{
        filePath:string
    }>(null)
    const [ldrAmount,rsAmount,exAmount] = useApiQuery("/core/sim/amount","post",amountData);


    const paymentData = useRef<{
        filePath:string
    }>(null)
    const [ldrPayment,rsPayment,exPayment] = useApiQuery("/core/sim/payment","post",paymentData);


    const socAddData = useRef<{
        filePath:string
        soc:string
        add:boolean
    }>(null)
    const [ldrSocAdd,rsSocAdd,exSocAdd] = useApiQuery("/core/sim/soc","post",socAddData);



    const [ldrSocAddTask, exSocAddTask] = useLongTask(100,5000, (state, data, code,cnt)=>onResultTaskTick(state, data,code,cnt),(state, data, code,cnt)=>onResultTaskTick(state, data,code,cnt),true)
    const [cnt, setCnt] = useState(0)
    const [work, setWork] = useState(false)
    const [workName, setWorkName] = useState("")


    const onResultTaskTick = (state: boolean, data:any , code:number ,cnt: number)=>{
        setCnt(cnt)
        if(data?.log && Array.isArray(data?.log) && loggerRef.current)loggerRef.current.log(data?.log)
        if(state)
        {
            if(stateRef.current)stateRef.current.show("Задача выполнена", false,0)
            setWork(false)
            return
        }


    }



    const changeTarifData = useRef<{
        filePath:string
        tarifId:string
    }>(null)
    const [ldrTarifChange,rsTarifChange,exTarifChange] = useApiQuery("/core/tarif/change","post",changeTarifData);

    const initTarifData = useRef<{
        filePath:string
        lockCode:number
        resetVolume:boolean
    }>(null)
    const [ldrInitTarif,rsInitTarif,exInitTarif] = useApiQuery("/core/tarif/init","post",initTarifData);



    const [lockList, setLockList] = useState<SelectUnitDataInt[]>([
        {
            name: "[0] Без блокировки",
            val: 0
        },
        {
            name: "[2] Блокирован перманентно",
            val: 2
        },
        {
            name: "[1] Блокирован",
            val: 1
        },
        {
            name: "[10] Старт",
            val: 10
        },
        {
            name: "[11] Не менять",
            val: 11
        },


    ])
    const [vLock, setVLock] = useState<any[]>([])
    const [vReset, setVReset] = useState<boolean>(true)


    const refBundleData = useRef(null)
    const [ldrRefBundle,rsRefBundle,exRefBundle] = useApiQuery("/ref/bundle","post",refBundleData);
    const [bundleList, setBundleList] = useState<SelectUnitDataInt[]>([])
    const [vBundle, setVBundle] = useState<any[]>([])


    const refTarifData = useRef<{bundleId?:string}>(null)
    const [ldrRefTarif,rsRefTarif,exRefTarif] = useApiQuery("/ref/tarif","post",refTarifData);
    const [tarifList, setTarifList] = useState<SelectUnitDataInt[]>([])
    const [vTarif, setVTarif] = useState<any[]>([])


    const [fileSelected, setFileSelected] = useState(false)

    const loggerRef = useRef<ILoggerItem>(null)
    const stateRef = useRef<ErrorLineItemRef>(null)


    const [soc,setSoc] = useState("")
    const [socAdd, setSocAdd] = useState(true)

    const data = useRef(new FormData())
    const [ldrXlsFile,rsXlsFile,exXlsFile] = useApiQuery("/excel/upload","file",data);
    const baseUrl = useSelector((state: ReduxStateInt) => {
        return state.baseUrl
    })


    useEffect(()=>{
        console.log("socadd", socAdd)
    },[socAdd])


    useEffect(()=>{
        loadBundleList()
        setVBundle([])
        setVTarif([])
    },[refBundleData])
    const loadBundleList = () =>{
        exRefBundle().then((e)=>{
            if(e?.success)
            {
                const x:SelectUnitDataInt[] = e?.payload?.map((item : any) => {
                    return {
                       name: item?.name ,
                       val: item?.bundleId
                    }
                })
                setBundleList(x)
            }
        })
    }
    const startWork = (name:string    ) =>{
        setCnt(0)
        setWork(true)
        if(loggerRef.current)loggerRef.current.clear()
        if(stateRef.current)stateRef.current.clear()
        setWorkName(name)
    }

    const loadTarifList = (bundleId: string) =>{
        if(! bundleId) return
        refTarifData.current = {
            bundleId: bundleId
        }
        exRefTarif().then((e)=>{
            if(e?.success)
            {
                const x:SelectUnitDataInt[] = e?.payload?.map((item : any) => {
                    return {
                        name: item?.name ,
                        val: item?.tarifId
                    }
                })
                setTarifList(x)
            }
        })
    }


    const handleFile = (e:React.ChangeEvent<HTMLInputElement>) =>{
        data.current.delete("file")
        if(! e.target.files)
        {
            setFileSelected(false)
            return
        }
        if(e.target.files.length > 0 )setFileSelected(true)
        else setFileSelected(false)
        data.current.append("file",e.target.files[0])
    }

    async function uploadFile(){
        return exXlsFile().then((e)=>{
            if(e?.success) return e?.payload
            return null
        })
    }

    async function handleInitTarif() {
        if(vLock?.length === 0)
        {
            if(stateRef.current)stateRef.current.show("Не выбран тип блокировки",true,5000)
            return
        }
        const file = await uploadFile()
        if(stateRef.current)stateRef.current.clear()
        initTarifData.current = {
            filePath: file,
            lockCode: vLock[0],
            resetVolume: vReset
        }
        startWork("Инициализация тарифов")
        exInitTarif().then((e)=>{
            if(e?.success)
            {
                console.log(e?.payload)
                if(e?.payload?.log && loggerRef.current)loggerRef.current.log(e?.payload?.log)
                if(stateRef.current)stateRef.current.show("Задача выполнена",false,5000)
                setWork(false)
                return
            }
            if(stateRef.current)stateRef.current.show(e?.errorAsString ? e?.errorAsString : "Ошибка сервера" ,true,0)
            setWork(false)

        }).catch((e)=>{
            if(stateRef.current)stateRef.current.show(e?.errorAsString ? e?.errorAsString : "Ошибка сервера" ,true,0)
            setWork(false)
        })



    }


    async function handleTarifChange(){
        console.log(vBundle, vTarif)
        if(vBundle?.length === 0 || vTarif.length === 0)
        {
            if(stateRef.current)stateRef.current.show("Не выбран тариф",true,5000)
            return
        }
        const file = await uploadFile()
        if(stateRef.current)stateRef.current.clear()
        changeTarifData.current = {
            filePath: file,
            tarifId: vTarif[0]
        }
        if(loggerRef.current)loggerRef.current.clear()
        startWork("Смена тарифов")
        exTarifChange().then((e)=>{
            if(e?.success)
            {
                console.log(e?.payload)
                if(e?.payload?.log && loggerRef.current)loggerRef.current.log(e?.payload?.log)
                if(stateRef.current)stateRef.current.show("Задача выполнена",false,5000)
                setWork(false)
                return
            }
            if(stateRef.current)stateRef.current.show(e?.errorAsString ? e?.errorAsString : "Ошибка сервера" ,true,0)
            setWork(false)

        }).catch((e)=>{
            if(stateRef.current)stateRef.current.show(e?.errorAsString ? e?.errorAsString : "Ошибка сервера" ,true,0)
            setWork(false)
        })


    }

    async function handleAmount(){
        const file = await uploadFile()
        if(stateRef.current)stateRef.current.clear()
        amountData.current = {
            filePath: file,
        }
        if(loggerRef.current)loggerRef.current.clear()
        startWork("Внесение балансов")
        exAmount().then((e)=>{
            if(e?.success)
            {
                console.log(e?.payload)
                if(e?.payload?.log && loggerRef.current)loggerRef.current.log(e?.payload?.log)
                if(stateRef.current)stateRef.current.show("Задача выполнена",false,5000)
                setWork(false)
                return
            }
            if(stateRef.current)stateRef.current.show(e?.errorAsString ? e?.errorAsString : "Ошибка сервера" ,true,0)
            setWork(false)

        }).catch((e)=>{
            if(stateRef.current)stateRef.current.show(e?.errorAsString ? e?.errorAsString : "Ошибка сервера" ,true,0)
            setWork(false)
        })


    }

    async function handlePayment(){
        const file = await uploadFile()
        if(stateRef.current)stateRef.current.clear()
        paymentData.current = {
            filePath: file,
        }
        if(loggerRef.current)loggerRef.current.clear()
        startWork("Внесение платежей")
        exPayment().then((e)=>{
            if(e?.success)
            {
                console.log(e?.payload)
                if(e?.payload?.log && loggerRef.current)loggerRef.current.log(e?.payload?.log)
                if(stateRef.current)stateRef.current.show("Задача выполнена",false,5000)
                setWork(false)
                return
            }
            if(stateRef.current)stateRef.current.show(e?.errorAsString ? e?.errorAsString : "Ошибка сервера" ,true,0)
            setWork(false)

        }).catch((e)=>{
            if(stateRef.current)stateRef.current.show(e?.errorAsString ? e?.errorAsString : "Ошибка сервера" ,true,0)
            setWork(false)
        })


    }

    async function handleSocAdd(){
        const file = await uploadFile()
        if(stateRef.current)stateRef.current.clear()
        socAddData.current = {
            filePath: file,
            soc: soc,
            add: socAdd
        }
        if(loggerRef.current)loggerRef.current.clear()
        startWork("Работа с soc")

        exSocAdd().then((e)=>{
            if(e?.success)
            {
                exSocAddTask(e?.payload)
                return
            }
            if(stateRef.current)stateRef.current.show(e?.errorAsString ? e?.errorAsString : "Ошибка сервера" ,true,0)
            setWork(false)

        }).catch((e)=>{
            if(stateRef.current)stateRef.current.show(e?.errorAsString ? e?.errorAsString : "Ошибка сервера" ,true,0)
            setWork(false)
        })


    }




    return(
        <div className={styles.mainCont}>
            <MainFormTemplate title={"Массовые операции"} maxWidth={"1000px"}>
                <div className={"row"}>
                    <div className={styles.ldrCont}>
                        <div className={styles.ldrTitle}>Прогресс работы</div>
                        <div className={styles.ldr}>
                            <WaitLoader loading={work} api={rsXlsFile} onlyLoading={true}>

                            </WaitLoader>
                            {work && <div className={styles.cntCont}>{cnt}</div>}
                        </div>
                        {work && <div className={styles.ldrTitle}>«{workName}»</div>}

                    </div>
                </div>


                <div className={"row"}>
                    <ErrorLineItem ref={stateRef}></ErrorLineItem>
                </div>
                <div className={"row"}>
                    <div className={"col-lg-12"}>
                        <div className={styles.inpCont}>
                            <Link to={`${baseUrl}/static/template/mass-template.xlsx`} className={styles.link}>Шаблон файла</Link>
                            <input type="file" className="form-control" accept={"application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"}
                                   onChange={(e)=>handleFile(e)}
                            >
                            </input>

                        </div>
                    </div>
                </div>

                <div className={styles.section}>
                    <div className={styles.secTitle}>Смена тарифа</div>
                    <div className={"row w-100"}>
                        <div className={styles.unitCnt}>
                            <SelectUnit capt={"Bundle"} inData={bundleList} getVal={(e)=>{
                                loadTarifList(e[0])
                                setVBundle(e)
                            }}/>

                            <SelectUnit capt={"Сменить тарифы"} inData={tarifList} getVal={(e)=>{
                                console.log(e)
                                setVTarif(e)
                            }}></SelectUnit>

                        </div>
                    </div>
                    <div className={"row w-100"}>
                        <div className={["col-sm-12 d-flex align-self-center", styles.btGr].join(' ')}>
                            <div className={styles.btnCont}>
                                <button type="button" className="btn btn-secondary "
                                        disabled={!fileSelected || work}
                                        onClick={()=>handleTarifChange()}
                                >Сменить</button>


                            </div>
                        </div>
                    </div>

                </div>
                <div className={styles.section}>
                    <div className={styles.secTitle}>Инициализация карт</div>
                    <div className={"row w-100"}>
                        <div className={styles.unitCnt}>
                            <div className={styles.cent}>
                                <SelectUnit capt={"Блокировка (next)"} inData={lockList} getVal={(e)=>{
                                    setVLock(e)
                                }}/>
                            </div>
                            <div className={styles.cent}>
                                <InputItem
                                    mode={"ie"}
                                    val={vReset}
                                    title={"Сбросить трафик"}
                                    inputType={1}
                                    info={"Сбросить трафик"}
                                    titleShift={-1}
                                    minWidth={"250px"}
                                    onChange={(e)=>{
                                        setVReset(e)
                                    }}
                                ></InputItem>
                            </div>
                        </div>
                    </div>

                    <div className={"row w-100"}>
                        <div className={styles.unitCnt}>

                        </div>
                    </div>
                    <div className={"row w-100"}>
                        <div className={["col-sm-12 d-flex align-self-center", styles.btGr].join(' ')}>
                            <div className={styles.btnCont}>
                                <button type="button" className="btn btn-secondary "
                                        disabled={!fileSelected || work}
                                        onClick={()=>handleInitTarif()}
                                >Выполнить</button>


                            </div>
                        </div>
                    </div>

                </div>
                <div className={styles.section}>
                    <div className={styles.secTitle}>Внести балансы</div>
                    <div className={"row w-100"}>
                        <div className={styles.unitCnt}>
                        </div>
                    </div>

                    <div className={"row w-100"}>
                        <div className={styles.unitCnt}>

                        </div>
                    </div>
                    <div className={"row w-100"}>
                        <div className={["col-sm-12 d-flex align-self-center", styles.btGr].join(' ')}>
                            <div className={styles.btnCont}>
                                <button type="button" className="btn btn-secondary "
                                        disabled={!fileSelected || work}
                                        onClick={()=>handleAmount()}
                                >Выполнить</button>


                            </div>
                        </div>
                    </div>

                </div>
                <div className={styles.section}>
                    <div className={styles.secTitle}>Внести платежи</div>
                    <div className={"row w-100"}>
                        <div className={styles.unitCnt}>
                        </div>
                    </div>

                    <div className={"row w-100"}>
                        <div className={styles.unitCnt}>

                        </div>
                    </div>
                    <div className={"row w-100"}>
                        <div className={["col-sm-12 d-flex align-self-center", styles.btGr].join(' ')}>
                            <div className={styles.btnCont}>
                                <button type="button" className="btn btn-secondary "
                                        disabled={!fileSelected || work}
                                        onClick={()=>handlePayment()}
                                >Выполнить</button>


                            </div>
                        </div>
                    </div>

                </div>
                <div className={styles.section}>
                    <div className={styles.secTitle}>SOC управление</div>
                    <div className={"row w-100"}>
                        <div className={styles.unitCnt}>
                            <div className={styles.cent}>
                                <InputItem
                                    mode={"ie"}
                                    val={soc}
                                    title={"SOC"}
                                    info={"SOC"}
                                    titleShift={-1}
                                    minWidth={"250px"}
                                    onChange={(e)=>{
                                        setSoc(e?.trim().toUpperCase())
                                    }}
                                ></InputItem>
                            </div>


                            <div className={styles.radioBut}>
                                <div className="form-check form-check-inline" onClick={()=>setSocAdd(true)}>
                                    <input className="form-check-input" type="radio" name="inlineRadioOptions" id="inlineRadio1"
                                           checked={socAdd}
                                           value="option1"/>
                                    <label className="form-check-label" htmlFor="inlineRadio1">Подключить</label>
                                </div>
                                <div className="form-check form-check-inline" onClick={()=>setSocAdd(false)}>
                                    <input className="form-check-input" type="radio" name="inlineRadioOptions" id="inlineRadio2"
                                           value="option2"/>
                                    <label className="form-check-label" htmlFor="inlineRadio2">Отключить</label>
                                </div>

                            </div>



                        </div>





                    </div>

                    <div className={"row w-100"}>
                        <div className={styles.unitCnt}>

                        </div>
                    </div>
                    <div className={"row w-100"}>
                        <div className={["col-sm-12 d-flex align-self-center", styles.btGr].join(' ')}>
                            <div className={styles.btnCont}>
                                <button type="button" className="btn btn-secondary "
                                        disabled={!fileSelected || work}
                                        onClick={()=>handleSocAdd()}
                                >Выполнить</button>


                            </div>
                        </div>
                    </div>

                </div>


                <div className={"row"}>
                    <div className={"col-sm-12 d-flex align-self-center"}>
                        <LoggerItem lineCount={10} ref={loggerRef} title={"Лог"}></LoggerItem>
                    </div>

                </div>

            </MainFormTemplate>

        </div>
    )
}